import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';

// import translation init
import './i18n';
import "./data/products"

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
